export const SEARCH_HS_CODE_PENDING = 'SEARCH_HS_CODE_PENDING';
export const SEARCH_HS_CODE_FULFILLED = 'SEARCH_HS_CODE_FULFILLED';
export const SEARCH_HS_CODE_FAILED = 'SEARCH_HS_CODE_FAILED';
